module.exports = __webpack_public_path__ + "img/TrustBy_Lancet.525fa86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_Lancet.jpg
// module id = 606
// module chunks = 5